/* src/app/dynamic-forms/form-view/form-view-image/form-view-image.component.css */
.mat-mdc-form-field {
  display: inline;
}
.post-thumb {
  align-items: center;
  align-content: center;
  display: flex;
  flex-direction: column;
  border: 1px solid currentColor;
  border-radius: 5px 5px 5px 5px;
  max-width: 100%;
  max-height: 100%;
}
.post-thumb img {
  max-width: 100%;
  max-height: 100%;
  min-width: 100%;
  min-height: 100%;
  width: 100%;
  height: 100%;
  vertical-align: middle;
  padding: 10px;
}
.mat-mdc-card-actions {
  align-items: flex-end;
}
.sideLeft {
  float: left;
  width: 25%;
}
.sideRight {
  float: right;
  width: 75%;
}
.example-form-field {
  width: 100%;
}
.content {
  width: 100%;
  display: flex;
}
.hide {
  display: none;
}
.pgbar {
  border: 1px solid currentColor;
  border-radius: 5px 5px 5px 5px;
}
.mat-mdc-form-field {
  width: 100%;
}
/*# sourceMappingURL=form-view-image.component.css.map */
